import React from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from '@material-ui/core'
import { Route, Switch } from 'wouter'

import withApp from 'artkive/hoc/withApp'
import routes from 'artkive/utils/routes'
import theme from 'artkive/utils/theme'

// TODO: Use wouter search params when upgraded to 3.0.0+, since 2.8 does not support them in SSR
export const ArtRecycleFlow = ({ email, order_number }) => {
  const search = `?email=${encodeURIComponent(email)}&order_number=${encodeURIComponent(order_number)}`

  return (
    <Box bgcolor={theme.colors.white.dark} minHeight={'100vh'}>
      <Container maxWidth={'md'}>
        <Box pt={8} mb={4} align={'center'}>
          <Switch>
            <Route path={routes.artRecycle}>
              <Grid container spacing={2}>
                <Grid xs={12} item>
                  <Typography variant={'h2'}>
                    Recycle Your Originals?
                  </Typography>

                  <Typography variant={'body1'}>
                    Your order will immediately be set to recycle. This decision cannot be undone.
                  </Typography>

                  <Box display={'flex'} justifyContent={'center'} my={2} gridGap={16}>
                    <Button
                      color={'secondary'}
                      href={routes.artRecycleCancel + search}
                      variant={'contained'}
                      className={'test-action-cancel'}
                    >
                      Cancel
                    </Button>
                    <form action={routes.artRecycleConfirm} method={'post'}>
                      <input type={'hidden'} name={'email'} value={email} />
                      <input type={'hidden'} name={'order_number'} value={order_number} />
                      <Button
                        color={'primary'}
                        variant={'contained'}
                        type={'submit'}
                        className={'test-action-recycle-art'}
                      >
                        Recycle My Originals
                      </Button>
                    </form>
                  </Box>
                </Grid>
              </Grid>
            </Route>
            <Route path={routes.artRecycleCancel}>
              <Grid container spacing={2}>
                <Grid xs={12} item>
                  <Typography variant={'h2'}>
                    Have your originals returned?
                  </Typography>

                  <Typography variant={'body1'}>
                    If you prefer, you can pay to have your originals returned.
                  </Typography>

                  <Box display={'flex'} justifyContent={'center'} my={2} gridGap={16}>
                    <form action={routes.artRecycleConfirm} method={'post'}>
                      <input type={'hidden'} name={'cancel'} value={'true'} />
                      <Button
                        color={'secondary'}
                        variant={'contained'}
                        type={'submit'}
                        className={'test-action-no-thanks'}
                      >
                        No, Thank You
                      </Button>
                    </form>
                    <Button
                      color={'primary'}
                      href={routes.artReturn + search}
                      variant={'contained'}
                      className={'test-action-return-art'}
                    >
                      Return My Originals
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Route>
          </Switch>
        </Box>
      </Container>
    </Box>
  )
}

ArtRecycleFlow.propTypes = {
  email: PropTypes.string.isRequired,
  order_number: PropTypes.number.isRequired,
}

export default withApp(ArtRecycleFlow)
